"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const global_colors = {
    yellow_itau: {
        color_yellowItau_20: '#FFFF00',
    },
    blue_itau: {
        color_blueItau_20: '#2D70BD',
        color_blueItau_50: '#003399',
    },
    orange_itau: {
        color_orangeItau_20: '#FD9D00',
        color_orangeItau_40: '#FF7500',
        color_orangeItau_50: '#EC7000',
        color_orangeItau_60: '#DD6100',
        color_orangeItau_70: '#C04500',
    },
    blue_warm: {
        color_blueWarm_50: '#106EB0',
        color_blueWarm_70: '#004480',
    },
    blue_warm_soft: {
        color_blueWarm_50: '#106eb01a',
    },
    blue_IBBA: {
        color_blueIBBA_50: '#2449CC',
        color_blueIBBA_70: '#192E76',
    },
    green_olive: {
        color_greenOlive_50: '#007A47',
    },
    yellow_mustard: {
        color_yellowMustard_50: '#F1AE2F',
        color_yellowMustard_80: '#A26B0B',
    },
    violet: {
        color_violet_50: '#781B8E',
    },
    red_ruby: {
        color_redRuby_50: '#D50000',
        color_redRuby_60: '#B71C1C',
    },
    sand: {
        color_sand_10: '#FAF7F5',
        color_sand_20: '#EFE9E5',
        color_sand_30: '#D6D0CC',
        color_sand_50: '#89837F',
        color_sand_70: '#706A66',
        color_sand_80: '#56504C',
        color_sand_90: '#231D19',
    },
    black_white: {
        color_black_strong: '#000000cc',
        color_black_medium: '#00000080',
        color_black: '#000000',
        color_white: '#FFFFFF',
        color_white_soft: '#FFFFFFCC',
        color_white_strong: '#FFFFFF1A',
        color_white_medium: '#FFFFFF80',
    },
};
exports.default = global_colors;
//# sourceMappingURL=global.js.map